import { render, staticRenderFns } from "./OrganisationOverview.vue?vue&type=template&id=2d939151&"
import script from "./OrganisationOverview.vue?vue&type=script&lang=ts&"
export * from "./OrganisationOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports